// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DevComponents_buttonContainer__3IDTj {\n  display: inline-block;\n  margin-right: 10px;\n  margin-bottom: 10px;\n  padding: 5px; }\n  .DevComponents_buttonContainer__3IDTj.DevComponents_background__1egxE {\n    background: #e5e5e5; }\n\n.DevComponents_avatarContainer__LoypO div {\n  margin: 5px; }\n  .DevComponents_avatarContainer__LoypO div > span {\n    margin: 5px; }\n", ""]);
// Exports
exports.locals = {
	"buttonContainer": "DevComponents_buttonContainer__3IDTj",
	"background": "DevComponents_background__1egxE",
	"avatarContainer": "DevComponents_avatarContainer__LoypO"
};
module.exports = exports;
